import { render, staticRenderFns } from "./1_franchise.vue?vue&type=template&id=c3968a98&scoped=true&"
import script from "./1_franchise.vue?vue&type=script&lang=js&"
export * from "./1_franchise.vue?vue&type=script&lang=js&"
import style0 from "./1_franchise.vue?vue&type=style&index=0&id=c3968a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3968a98",
  null
  
)

export default component.exports